import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axios from "axios";
import { BASE_END_POINT } from "./urls";


const firebaseConfig = {
  apiKey: "AIzaSyBsYOVXzUy0Eaynq5DwuC7FWXl0_2-YN7I",
  authDomain: "ahya-pals-pro.firebaseapp.com",
  projectId: "ahya-pals-pro",
  storageBucket: "ahya-pals-pro.firebasestorage.app",
  messagingSenderId: "395826023312",
  appId: "1:395826023312:web:1470316011cd03000ec115",
  measurementId: "G-6QEBH4SCFF"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = async (authToken, isRTL) => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BEh7b4KEoDTb-k0NH_xATSf2QUt22mqd6J-WY_xXACbH8okUu2HHqn7jV05l2EF70k1f5_uji8WZz-M3pNbWZHI",
    });

    if (currentToken) {
      console.log("🔥 FCM Token:", currentToken);

      await axios.post(`${BASE_END_POINT}addToken`,{ token: currentToken },
        {headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
            "Accept-Language": isRTL ? "ar" : "en",
          },
        }
      );
      console.log("✅ Token sent to backend");
    } else {
      console.log("⚠️ No registration token available.");
    }
  } catch (err) {
    console.error("😥 Error while retrieving token: ", err);
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
